export default {"src":"/_next/static/media/search_icon.4572e1f4.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};